import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getProductDisclaimers, openSnackbar, updateDisclaimer } from '../../redux/slices/common';
import { Box, Card, Stack, Typography } from '@mui/material';
import EditIcon from 'common/customIcons/edit';
import MDButton from 'components/MDButton';
import CommonQuillEditor from 'common/editor';
import { grey } from '@mui/material/colors';
import { getData } from 'utilities/common';
import { getPermissionsByMode } from 'utilities/common';
import { hasSectionPermission } from 'utilities/common';

export default function ManageDisclaimers() {
  const { disclaimers, isLoading = false } = useSelector(state => state.common);
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [disclaimersValue, setDisclaimers] = useState('');

  useEffect(() => {
    if (disclaimers?.productDisclaimer || disclaimers?.data?.productDisclaimer) {
      setDisclaimers(disclaimers?.productDisclaimer || disclaimers?.productDisclaimer || disclaimers?.data?.productDisclaimer);
    }
  }, [disclaimers]);

  let localUser = getData('login-user-info')
  if (localUser) {
    localUser = JSON.parse(localUser)
  }

  const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
  const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

  const canCreate = hasSectionPermission(permissionsForMode, "Product", "Create");
  const canEdit = hasSectionPermission(permissionsForMode, "Product", "Edit/Update");
  const canView = hasSectionPermission(permissionsForMode, "Product", "View Only");
  const canDelete = hasSectionPermission(permissionsForMode, "Product", "Delete");

  const disclaimerUpdateHandler = () => {
    dispatch(updateDisclaimer({ productDisclaimer: disclaimersValue })).unwrap().then((res) => {
      showResponseMessage(res?.message || res?.data?.message, 'success');
      dispatch(getProductDisclaimers());
      setIsEdit(false);
    });
  };

  const showResponseMessage = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };

  useEffect(() => {
    dispatch(getProductDisclaimers());
  }, []);

  return (
    <CommonLayout>
      {
        canView &&
        <Box p={{ xs: 2, sm: 3, lg: 4 }}>
          <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, boxShadow: 'none' }}>
            {
              isEdit ? <>
                <Stack direction={{ xs: 'column', sm: 'column' }} justifyContent="space-between" gap={2} mb={2}>
                  <Typography variant="h5" fontWeight="semibold" color={grey[600]} mb={1}>Edit Disclaimer</Typography>
                  <CommonQuillEditor
                    style={true} height={"300px"}
                    value={disclaimersValue || ''}
                    onChange={(value) => setDisclaimers(value)}
                  />
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} gap={2}>
                  <MDButton
                    type='button'
                    variant='contained'
                    size="small"
                    color='primary'
                    style={{ width: 150, padding: 10 }}
                    onClick={disclaimerUpdateHandler}
                    disabled={isLoading}
                    loading={isLoading}
                  >
                    Save
                  </MDButton>
                  <MDButton
                    type='button'
                    variant='outlined'
                    size="small"
                    color='primary'
                    style={{ width: 150, padding: 10 }}
                    onClick={() => {
                      setDisclaimers(disclaimers?.productDisclaimer || disclaimers?.productDisclaimer || disclaimers?.data?.productDisclaimer);
                      setIsEdit(false)
                    }}
                  >
                    Cancel
                  </MDButton>
                </Stack>
              </> : <>
                <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent="space-between" gap={2} mb={4.5}>
                  <Typography variant="h4" fontWeight="semibold">Disclaimer</Typography>
                  {
                    canEdit &&
                    <MDButton
                      type='button'
                      variant='outlined'
                      color='dark'
                      size="small"
                      startIcon={<EditIcon width='15px' height='15px' />}
                      onClick={() => setIsEdit(true)}
                    >
                      {disclaimersValue ? 'Edit' : 'Add'}
                    </MDButton>
                  }
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent="space-between" gap={2} mb={4.5}>
                  <div className='text-18' dangerouslySetInnerHTML={{ __html: disclaimersValue }}></div>
                </Stack>
              </>
            }
          </Card>
        </Box>
      }
    </CommonLayout>
  );
}